import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  navigation: function navigation(state) {
    return state.navigation;
  },
  navigationServices: function navigationServices(state) {
    return state.navigationServices;
  }
};